import { EnumSchema, FromSchema } from '@40seas/entities/common';
import { z } from 'zod';
import { UserRole } from '@40seas/entities/users';
import { NotificationDefinitionStatus } from './notification-definition.status';
import { RecipientsProviderType } from './recipients/recipients.provider.type';

export const NotificationDefinitionEventTypeSchema = z
    .object({
        id: z.string().min(1),
        eventType: z.string().min(1),
        role: EnumSchema(UserRole),
        templateId: z.string(),
        recipientsProviderType: z.array(EnumSchema(RecipientsProviderType)),
        isPrimary: z.boolean(),
        recipientEmails: z.array(z.string()),
    })
    .strict();
export class NotificationDefinitionEventType extends FromSchema(NotificationDefinitionEventTypeSchema) {
    id: string; // {role}_{eventType}
    eventType: string;
    role: UserRole;
    templateId: string;
    status: NotificationDefinitionStatus;
    recipientsProviderType: RecipientsProviderType[];
    isPrimary: boolean;
    recipientEmails: string[];
}
